import { Table, Tooltip } from 'antd';
import AntdTable from 'components/AntdTable';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useModalConfirm from 'hook/useModalConfirm';
import { TooltipHide } from 'page/Application/ManageCompanyList/CompanyList/styled';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useMultiLanguageExportLog from '../hook/useMultiLanguageExportLog';

dayjs.extend(utc);
dayjs.extend(timezone);

const TableData = ({ dataRaw, isLoading, emptyText }) => {
  const navigate = useNavigate();

  const {
    EXPORT_LOG_LIST_TABLE_TIME,
    EXPORT_LOG_LIST_TABLE_EMAIL,
    EXPORT_LOG_LIST_TABLE_TYPE,
  } = useMultiLanguageExportLog();

  const { contextHolder } = useModalConfirm();
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();

  const columns = useMemo(() => {
    return [
      Table.SELECTION_COLUMN,
      {
        key: 'timestamp',
        title: (
          <TooltipHide>
            <Tooltip title={EXPORT_LOG_LIST_TABLE_TIME} placement={'topLeft'}>
              {EXPORT_LOG_LIST_TABLE_TIME}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'timestamp',
        align: 'left',
        render: (time) => {
          const japaneseTime = time
            ? dayjs.utc(time).tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss')
            : '';
          return (
            <TooltipHide>
              <Tooltip title={japaneseTime} placement={'topLeft'}>
                {japaneseTime}
              </Tooltip>
            </TooltipHide>
          );
        },
      },
      {
        key: 'email',
        title: (
          <TooltipHide>
            <Tooltip title={EXPORT_LOG_LIST_TABLE_EMAIL} placement={'topLeft'}>
              {EXPORT_LOG_LIST_TABLE_EMAIL}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'email',
        align: 'left',
        ellipsis: true,
        render: (email) => (
          <TooltipHide>
            <Tooltip title={email} placement={'topLeft'}>
              {email}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'type',
        title: (
          <TooltipHide>
            <Tooltip title={EXPORT_LOG_LIST_TABLE_TYPE} placement={'topLeft'}>
              {EXPORT_LOG_LIST_TABLE_TYPE}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'type',
        align: 'left',
        ellipsis: true,
        render: (type) => {
          let japaneseType = '';

          if (type === 'VIEW') {
            japaneseType = '閲覧';
          } else if (type === 'DOWNLOAD') {
            japaneseType = 'ファイルDL';
          } else if (type === 'CLICK_EXTERNAL_LINK') {
            japaneseType = '外部リンク';
          } else if (type === 'LOGIN') {
            japaneseType = 'ログイン';
          }

          return (
            <TooltipHide>
              <Tooltip title={japaneseType} placement={'topLeft'}>
                {japaneseType}
              </Tooltip>
            </TooltipHide>
          );
        },
      },
      {
        key: 'url',
        title: (
          <TooltipHide>
            <Tooltip title="URL" placement={'topLeft'}>
              URL
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'url',
        align: 'left',
        ellipsis: true,
        render: (url) => (
          <TooltipHide>
            <Tooltip title={url} placement={'topLeft'}>
              {url}
            </Tooltip>
          </TooltipHide>
        ),
      },
    ];
  }, [navigate, isOnline, errorNetWork]);

  // format data for render table
  const dataSource = useMemo(() => {
    if (isLoading && !dataRaw) return [];
    return dataRaw?.list?.map((item) => ({
      ...item,
      key: item.id,
    }));
  }, [dataRaw, isLoading]);

  return (
    <>
      {contextHolder}
      {contextErrorNetWork}
      <AntdTable
        columns={columns}
        isLoading={isLoading}
        dataSource={dataSource}
        emptyText={emptyText}
      />
    </>
  );
};

export default TableData;
